import { render, staticRenderFns } from "./notification-rules.vue?vue&type=template&id=7e5f8e36&scoped=true"
import script from "./notification-rules.vue?vue&type=script&setup=true&lang=js"
export * from "./notification-rules.vue?vue&type=script&setup=true&lang=js"
import style0 from "./notification-rules.vue?vue&type=style&index=0&id=7e5f8e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5f8e36",
  null
  
)

export default component.exports